<template>
  <div class="app-container">
    <el-button type="primary" size="small" @click="goBack">返回</el-button>

    <!-- 顶部栏 -->
    <div class="topbar" style="padding-top: 20px">
      <div>
        <el-input v-model="searchValue" placeholder="" size="small" prefix-icon="el-icon-search"
                  class="search-input" @keyup.native.enter="search()" clearable/>
        <el-button type="primary" icon="el-icon-search" size="small" @click.stop="search()">
          搜索
        </el-button>
      </div>
    </div>

    <el-table border ref="tableData" v-loading="loading" :data="tableData"
              :header-cell-style="{ background: '#F5F7FA' }" style="width: 100%; margin-bottom: 20px;margin-top: 20px;">
      <el-table-column type="expand">
        <template #default="scope">
          <el-table v-if="scope.row.answerCommentFileList.length > 0" :data="scope.row.answerCommentFileList">
            <el-table-column prop="answerCommentFileId" label="#" align="center"></el-table-column>
            <el-table-column prop="" label="文件" align="center">
              <template #default="scope">

                <audio v-if="scope.row.fileType === 2" :src="getCloudUrl(scope.row.fileUrl)" controls
                       type="audio/m4a"></audio>

                <div style="width: 100px; height: 100px;position: relative; display: flex;justify-content: center;">
                  <el-image fit="scale-down"
                            :src="getImageUrl(scope.row)" lazy :key="getImageUrl(scope.row)"
                            :preview-src-list="[getImageUrl(scope.row)]">
                  </el-image>
                  <i v-if="scope.row.fileType === 1" class="el-icon-video-play"
                     style="font-size: 30px;position: absolute;top: 35px;left: 35px;color: aliceblue;"
                     @click.stop="previewVideo(scope.row)"></i>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="" label="上传时间" align="center">
              <template #default="scope">
                {{ scope.row.createTime | formatDateTime }}
              </template>
            </el-table-column>
          </el-table>
          <p v-else>没有文件数据</p>
        </template>
      </el-table-column>
      <el-table-column prop="answerCommentID" label="#" align="center"></el-table-column>
      <el-table-column prop="replier" label="评论者" align="center" show-overflow-tooltip>
        <template #default='scope'>
          <user-info :user="scope.row"></user-info>
        </template>
      </el-table-column>
      <el-table-column prop="content" label="评论内容" align="center"></el-table-column>
      <el-table-column prop="createTime" label="评论时间" align="center">
        <template #default="scope">
          {{ scope.row.createTime | formatDateTime }}
        </template>
      </el-table-column>
      <el-table-column prop="op" label="操作" align="center">
        <template #default="scope">
          <el-button type="primary" size="small" @click="viewReply(scope.row)">查看回复</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination background :total="commentPageOpt.total"
                   :page-size="commentPageOpt.pageSize" :current-page="commentPageOpt.curPage"
                   @current-change="commentCurPageChange"/>

    <el-dialog :visible.sync="replyDlg" width="80%">
      <!-- 顶部栏 -->
      <div class="topbar" style="padding-top: 20px">
        <div>
          <el-input v-model="replySearchValue" placeholder="" size="small" prefix-icon="el-icon-search"
                    class="search-input" @keyup.native.enter="replySearch()" clearable/>
          <el-button type="primary" icon="el-icon-search" size="small" @click.stop="replySearch()">
            搜索
          </el-button>
        </div>
      </div>

      <el-table border ref="tableData" v-loading="replyLoading" :data="replyData"
                :header-cell-style="{ background: '#F5F7FA' }"
                style="width: 100%; margin-bottom: 20px;margin-top: 20px;height: 60vh;overflow: auto">
        <el-table-column type="expand">
          <template #default="scope">
            <el-table v-if="scope.row.answerCommentFileList.length > 0" :data="scope.row.answerCommentFileList">
              <el-table-column prop="answerCommentFileId" label="#" align="center"></el-table-column>
              <el-table-column prop="" label="文件" align="center">
                <template #default="scope">

                  <audio v-if="scope.row.fileType === 2" :src="getCloudUrl(scope.row.fileUrl)" controls
                         type="audio/m4a"></audio>

                  <div style="width: 100px; height: 100px;position: relative; display: flex;justify-content: center;">
                    <el-image fit="scale-down"
                              :src="getImageUrl(scope.row)" lazy :key="getImageUrl(scope.row)"
                              :preview-src-list="[getImageUrl(scope.row)]">
                    </el-image>
                    <i v-if="scope.row.fileType === 1" class="el-icon-video-play"
                       style="font-size: 30px;position: absolute;top: 35px;left: 35px;color: aliceblue;"
                       @click.stop="previewVideo(scope.row)"></i>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="" label="上传时间" align="center">
                <template #default="scope">
                  {{ scope.row.createTime | formatDateTime }}
                </template>
              </el-table-column>
            </el-table>
            <p v-else>没有文件数据</p>
          </template>
        </el-table-column>
        <el-table-column prop="answerCommentID" label="#" align="center"></el-table-column>
        <el-table-column prop="replier" label="评论者" align="center">
          <template #default='scope'>
            <user-info :user="scope.row"></user-info>
          </template>
        </el-table-column>
        <el-table-column prop="content" label="评论内容" align="center"></el-table-column>
        <el-table-column prop="createTime" label="评论时间" align="center" show-overflow-tooltip>
          <template #default="scope">
            {{ scope.row.createTime | formatDateTime }}
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background :total="replayCommentPageOpt.total"
                     :page-size="replayCommentPageOpt.pageSize" :current-page="replayCommentPageOpt.curPage"
                     @current-change="commentReplyCurPageChange"/>
    </el-dialog>

    <el-dialog :visible.sync="previewVideoDlg" width="60%" :destroy-on-close="true">
      <tx-video-player style="height: 60vh" :video-url="previewVideoUrl"></tx-video-player>
    </el-dialog>
  </div>

</template>

<script>
import {getAnswerCommentList, getAnswerCommentReplyList} from "@/api/mai/quizManagement/quizDetail";
import {handleRes} from "@/utils/handleRes";
import {isVaild} from "@/utils/validate";
import UserInfo from "@/components/UserInfo/UserInfo";
import {getCloudUrl, getPreviewImgUrl} from "@/utils/urlutil";
import TxVideoPlayer from "@/components/TXVideoPlayer/txVideoPlayer";

export default {
  name: "answerReply",
  components: {TxVideoPlayer, UserInfo},
  data() {
    return {
      problemAnswerId: 0,
      searchValue: "",
      loading: false,
      commentPageOpt: {
        curPage: 1,
        pageSize: 10,
        total: 0
      },
      tableData: [],

      //评论回复
      replyDlg: false,
      replySearchValue: "",
      replyLoading: false,
      replayCommentPageOpt: {
        curPage: 1,
        pageSize: 10,
        total: 0
      },
      replyData: [],

      previewVideoUrl: "",
      previewVideoDlg: false

    }
  },
  created() {
    if (isVaild(this.$route.query.problemAnswerId)) {
      this.problemAnswerId = this.$route.query.problemAnswerId
    }
    this.getAnswerCommentList()
  },
  methods: {
    getCloudUrl(path) {
      return getCloudUrl(path)
    },
    getImageUrl(entity) {
      return getPreviewImgUrl(entity)
    },
    previewVideo(entity) {
      this.previewVideoUrl = this.getCloudUrl(entity.fileUrl)
      this.previewVideoDlg = true
    },
    goBack() {
      this.$router.go(-1)
    },
    search() {
      this.refreshList()
    },
    refreshList() {
      this.commentPageOpt.curPage = 1
      this.getAnswerCommentList()
    },
    commentCurPageChange(curPage) {
      this.commentPageOpt.curPage = curPage
      this.getAnswerCommentList()
    },
    getAnswerCommentList() {
      this.loading = true;
      let params = {
        sortName: "",
        sortOrder: "",
        problemAnswerId: this.problemAnswerId,
        pageNumber: this.commentPageOpt.curPage,
        pageSize: this.commentPageOpt.pageSize,
        keyWord: this.searchValue,
      }
      getAnswerCommentList(params).then((res) => {
        handleRes(res, () => {
          this.commentPageOpt.total = res.data.total
          this.tableData = res.data.rows
        })
        this.utils.stopLoading(this)
      })
    },
    viewReply(entity) {
      this.relativeCommentId = entity.answerCommentID
      this.replyDlg = true
      this.getAnswerCommentReplyList()
    },
    //评论回复相关

    replySearch() {
      this.replyRefreshList()
    },
    commentReplyCurPageChange(curPage){
      this.replayCommentPageOpt.curPage = curPage
      this.getAnswerCommentReplyList()
    },
    replyRefreshList() {
      this.replayCommentPageOpt.curPage = 1
      this.getAnswerCommentReplyList()
    },
    getAnswerCommentReplyList() {
      this.replyLoading = true
      let params = {
        sortName: "",
        sortOrder: "",
        relativeCommentId: this.relativeCommentId,
        problemAnswerId: this.problemAnswerId,
        pageNumber: this.replayCommentPageOpt.curPage,
        pageSize: this.replayCommentPageOpt.pageSize,
        keyWord: this.replySearchValue,
      }
      getAnswerCommentReplyList(params).then(res => {
        handleRes(res, () => {
          // this.replyDlg = true
          this.replyData = res.data.rows
          this.replayCommentPageOpt.total = res.data.total
        })
        this.replyLoading = false
      })
    }
  },
}
</script>

<style scoped>

</style>